// @ts-nocheck


import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'
import Slider from 'react-slick'

export default function WomenCategorySlider({ colletionData, subCategoryRoute }) {
  const router = useRouter()

  const SampleNextArrow = (props) => {
    const { onClick } = props
    return (
      <div className="slick-arrow slick-next" onClick={onClick}>
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 1L1 6L5 11" stroke="#1E2432" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    )
  }

  const SamplePrevArrow = (props) => {
    const { onClick } = props
    return (
      <div className={'slick-arrow slick-prev'} onClick={onClick}>
        <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 1L1 6L5 11" stroke="#1E2432" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    )
  }

  const settings_Slider2 = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 8,
    slidesToScroll: 8,
    autoplay: false,
    variableWidth: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 1440,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 4,
        settings: {
          slidesToShow: 8.5,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 8.5,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 968,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  }

  

  return (
    <>
      {/* <div className="category_slider">
        <Slider {...settings_Slider2}>
          <div className="Category_slider_cover">
            <div className="catagory_block" style={{ width: 'fit-content', textAlign: 'center' }}>
              <div className="box_cover box_radius">
                <div className="box active box">
                  <div className="img_cover">
                  </div>
                </div>
              </div>
              <p>hello</p>
            </div>
          </div>
        </Slider>
      </div> */}
      <div className="category_slider">
        <Slider {...settings_Slider2}>
          {colletionData?.map((childSubCategory, index) => {
            return (
              <React.Fragment key={index}>
                <Link href={`/fashion/${subCategoryRoute}/${childSubCategory?.slug}`} scroll={false}>
                  <div className="Category_slider_cover">
                    <div className="catagory_block" style={{ width: 'fit-content', textAlign: 'center' }}>
                      <div
                        className={router?.query?.id === childSubCategory.slug ? 'box_cover box_radius' : 'box_cover'}
                      >
                        <div className={router?.query?.id === childSubCategory.slug ? 'box active' : 'box'}>
                          <div className="img_cover">
                            <img src={childSubCategory?.media} alt="Category_slider_cover_img" />
                          </div>
                        </div>
                      </div>
                      <p>{childSubCategory?.name}</p>
                    </div>
                  </div>
                </Link>
              </React.Fragment>
            )
          })}
        </Slider>
      </div>
    </>
  )
}
